import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createPharmaSalesSlice = createAsyncThunk(
  "PharmaSales/createPharmaSales",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/PharmaSales/createPharmaSales",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAllPharmaSalesSlice = createAsyncThunk(
  "PharmaSales/getAllPharmaSales",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/PharmaSales/getAllPharmaSales",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getPharmaSalesByIdSlice = createAsyncThunk(
  "PharmaSales/getPharmaSalesById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/pharmaSales/getPharmaSalesById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const updatePharmaSalesSlice = createAsyncThunk(
  "PharmaSales/updatePharmaSales",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/pharmaSales/updatePharmaSales", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const refundPharmaSalesSlice = createAsyncThunk(
  "PharmaSales/refundPharmaSalesSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/pharmaSales/refundPharmaSales",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const cancelPharmaSalesSlice = createAsyncThunk(
  "PharmaSales/cancelPharmaSalesSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/pharmaSales/cancelPharmaSales",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getPharmaCollectionSlice = createAsyncThunk(
  "PharmaSales/getPharmaCollection",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/pharmaSales/getPharmaCollection",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
)
const initialState = {
  pharmaSales: [],
  pharmaSalesInfo: [],
  pharmaSalesCollection: [],
  isLoading: false,
  createPharmaSalesSuccessMessage: null,
  createPharmaSalesErrorMessage: null,
  updatePharmaSalesSuccessMessage: null,
  updatePharmaSalesErrorMessage: null,
  searchPharmaSalesErrorMessage: null,
  refundPharmaSalesSuccessMessage: null,
  refundPharmaSalesErrorMessage: null,
  cancelPharmaSalesSuccessMessage: null,
  cancelPharmaSalesErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const pharmaSalesSlice = createSlice({
  name: "pharmaSales",
  initialState,
  reducers: {
    resetAddPharmaSalesMessage: (state) => {
      state.createPharmaSalesSuccessMessage = null;
      state.createPharmaSalesErrorMessage = null;
    },
    resetUpdatePharmaSalesMessage: (state) => {
      state.updatePharmaSalesSuccessMessage = null;
      state.updatePharmaSalesErrorMessage = null;
    },
    resetRefundPharmaSalesMessage: (state) => {
      state.refundPharmaSalesSuccessMessage = null;
      state.refundPharmaSalesErrorMessage = null;
    },
    resetCancelPharmaSalesMessage: (state) => {
      state.cancelPharmaSalesSuccessMessage = null;
      state.cancelPharmaSalesErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPharmaSalesSlice.pending, (state) => {
        state.isLoading = true;
        state.createPharmaSalesSuccessMessage = null;
        state.createPharmaSalesErrorMessage = null;
      })
      .addCase(createPharmaSalesSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createPharmaSalesErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.createPharmaSalesSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(createPharmaSalesSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAllPharmaSalesSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllPharmaSalesSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          state.pharmaSales = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchPharmaSalesErrorMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.pharmaSales = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchPharmaSalesErrorMessage = null;
      })
      .addCase(getAllPharmaSalesSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchPharmaSalesErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getPharmaSalesByIdSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPharmaSalesByIdSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pharmaSalesInfo = action?.payload?.result?.list;
      })
      .addCase(getPharmaSalesByIdSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchPharmaSalesErrorMessage = action?.payload?.result?.message;
      })
      .addCase(updatePharmaSalesSlice.pending, (state) => {
        state.isLoading = true;
        state.updatePharmaSalesSuccessMessage = null;
        state.updatePharmaSalesErrorMessage = null;
      })
      .addCase(updatePharmaSalesSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.updatePharmaSalesErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.updatePharmaSalesSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(updatePharmaSalesSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(refundPharmaSalesSlice.pending, (state) => {
        state.isLoading = true;
        state.refundPharmaSalesSuccessMessage = null;
        state.refundPharmaSalesErrorMessage = null;
      })
      .addCase(refundPharmaSalesSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.refundPharmaSalesErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.refundPharmaSalesSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(refundPharmaSalesSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(cancelPharmaSalesSlice.pending, (state) => {
        state.isLoading = true;
        state.cancelPharmaSalesSuccessMessage = null;
        state.cancelPharmaSalesErrorMessage = null;
      })
      .addCase(cancelPharmaSalesSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.cancelPharmaSalesErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.cancelPharmaSalesSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(cancelPharmaSalesSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getPharmaCollectionSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPharmaCollectionSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.searchPharmaSalesErrorMessage =
            action?.payload?.result?.message;
        }
        state.pharmaSalesCollection = action?.payload?.result?.list;
      })
      .addCase(getPharmaCollectionSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchPharmaSalesErrorMessage = action?.payload?.result?.message;
      });
  },
});
export const {
  resetAddPharmaSalesMessage,
  resetUpdatePharmaSalesMessage,
  resetRefundPharmaSalesMessage,
  resetCancelPharmaSalesMessage,
} = pharmaSalesSlice.actions;

export default pharmaSalesSlice.reducer;
